
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { EpbText } from '../shared/epb-text'
import XTogglePanel from '../x/x-toggle-panel.component.vue'

export interface EpbAccordionSection {
  id: string
  title?: string
  disabled?: boolean
}

export default defineComponent({
  name: 'EpbAccordion',
  components: {
    EpbText,
    XTogglePanel,
  },
  props: {
    sections: {
      type: Array as PropType<Array<EpbAccordionSection>>,
      required: true,
    },
  },
  setup() {
    const baseClass = 'epb-accordion'

    return {
      baseClass,
    }
  },
})
